module.exports = __webpack_public_path__ + "media/8.526e9509.mp3";